import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import useBreadcrumbText from "./useBreadCrumbText";
import { NavLink } from "react-router-dom";
import "./BreadCrumbs.css";

export default function BreadCrumbs() {
  const crumbs = useBreadcrumbText();        

  return (
    <Box component="span" className="breadcrumb-container">
        {
            crumbs.map((crumb, index) => (
                <Box component="span" key={index}>
                    <Link
                        component={NavLink}
                        to={crumb.href}
                        sx={{
                            textDecoration: 'none',
                            color: 'text.primary',
                            '&:hover': {
                                color: 'text.primary'
                            }
                        }}
                    >
                        {crumb.text}
                    </Link>
                    <Box
                        component="span"
                        sx={{
                            color: 'text.primary',
                            '&:hover': {
                                color: 'text.primary'
                            }
                        }}
                    >
                        {' / '}
                    </Box>
                </Box>
            ))
        }
    </Box>
  )
}
